import isEmpty from 'lodash/isEmpty';

import {isEmptyFlowsResult} from 'common/report/flows/util';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {LocalizationStore} from 'common/i18n/store';
import {Bookmark, TimeFilter} from 'common/report/dashboards/types';
import {FlowsBookmark} from 'common/report/flows/models/types';

import {getDateRangeLabelForDashboardCards} from '../util/dashboard';

export function getChartDescription({
  bookmark,
  timeFilter,
  i18n,
}: {
  bookmark: Bookmark<FlowsBookmark>;
  timeFilter: TimeFilter;
  i18n: LocalizationStore;
}): string {
  const dateRangeLabel = getDateRangeText(timeFilter, bookmark, i18n);

  const params = bookmark.params;

  const numberOfAnchors = params.steps?.length;
  const numberOfSteps =
    params.steps.map((event) => (event[`forward`] || 0) + (event[`reverse`] || 0)).reduce((acc, val) => acc + val, 0) +
    numberOfAnchors;

  return `${i18n.t(`boards.cards.report-header.multi-step-flow`, {count: numberOfSteps})} • ${dateRangeLabel}`;
}

export {isEmptyFlowsResult};

function getDateRangeText(timeFilter: TimeFilter, bookmark: Bookmark<FlowsBookmark>, i18n: LocalizationStore): string {
  const dateRange = !isEmpty(timeFilter)
    ? new DateRange(timeFilter.dateRange)
    : DateRange.fromBookmarkFormat(bookmark.params.date_range);
  const dateRangeLabel = i18n
    ? getDateRangeLabelForDashboardCards({dateRange})
    : getDateRangeLabelForDashboardCards({dateRange, asString: true});

  if (typeof dateRangeLabel === `string`) {
    return dateRangeLabel;
  }
  return i18n.print(dateRangeLabel);
}
